<template>
    <div v-loading.fullscreen.lock="state.fullLoading" element-loading-background="rgba(0, 0, 0, 0.3)">
        <el-card class="box-card" :body-style="{ padding: '8px' }">
            <el-page-header content="维保品牌管理" :icon="null" title="品牌管理">
                <template #extra>
                    <el-button type="primary" @click="handleAdd()">新增品牌</el-button>
                    <el-button @click="searchFun(1)">刷新</el-button>
                    <el-button @click="searchFun(2)">重置</el-button>
                </template>
            </el-page-header>
            <el-table :data="tableData" border style="width: 100%;margin-top: 8px;" height="calc(100vh - 193px)"
                row-key="id" v-loading="state.tableLoading" show-overflow-tooltip>
                <el-table-column label="#" type="index" :index="indexMethod" align="center" width="50px" />
                <el-table-column prop="brandName" label="品牌名称">
                    <template #header>
                        <div class="header-cell" :class="{ 'header-cell_active': search.brandName }">
                            <span>品牌名称</span>
                            <el-icon ref="triggerRefBrandName">
                                <Filter />
                            </el-icon>
                        </div>
                    </template>
                </el-table-column>
                <el-table-column prop="createTime" label="创建时间" />
                <!-- <el-table-column prop="iconUrl" label="品牌图标">
                    <template #default="scope">
                        <el-text class="mx-1" type="primary">
                            {{ scope.row.iconUrl }}
                        </el-text>
                    </template>
                </el-table-column> -->
                <el-table-column fixed="right" label="操作" width="80px">
                    <template #default="scope">
                        <el-popconfirm title="是否要删除当前数据?" confirm-button-text="是" cancel-button-text="否"
                            @confirm="handleDelete(scope.row)">
                            <template #reference>
                                <el-button type="danger" size="small">删除</el-button>
                            </template>
                        </el-popconfirm>
                    </template>
                </el-table-column>
            </el-table>
            <div class="pagination-box">
                <el-pagination background layout="total,sizes,prev, pager, next"
                    v-model:current-page="pagination.current" v-model:page-size="pagination.size"
                    :total="pagination.total" :page-sizes="pagination.sizes" :page-size="pagination.size"
                    prev-text="上一页" next-text="下一页" @current-change="intTableData" @size-change="intTableData" />
                <div style="clear: both;"></div>
            </div>
        </el-card>
    </div>
    <el-dialog v-model="state.dialogVisible" :title="state.formValue.type == 1 ? '新增品牌' : '编辑品牌'" width="40%">
        <el-form ref="userFormRef" :model="state.formValue" :rules="state.formRules" label-width="90px" status-icon>
            <el-form-item label="品牌名称:" prop="brandName">
                <el-select-v2 v-model="state.formValue.brandName" :options="state.options2" fit-input-width filterable
                    class="m-2" placeholder="请选择品牌" style="width: 100%" :filter-method="filterMethod2"
                    @change="selectNode" />
            </el-form-item>
        </el-form>
        <template #footer>
            <span class="dialog-footer">
                <el-button @click="state.dialogVisible = false">取消</el-button>
                <el-button type="primary" @click="dialogConfirm">确认</el-button>
            </span>
        </template>
    </el-dialog>
    <!-- 筛选popover -->
    <FilterText @handleSearch="handleSearch" :triggerRef="triggerRefBrandName" field="brandName" :formValue="search"
        placeholder="请输入品牌名称" />
</template>
<script setup>
import { reactive, ref, onMounted } from "vue";
import { Filter } from '@element-plus/icons-vue'
import { getThirdBrand, getBrandListFun, deleteFun, brandAddFun } from "@/api/brand"
import FilterText from '@/components/TableFilter/FilterText.vue'

const triggerRefBrandName = ref();// 手机号筛选ref

const search = reactive({
    brandName: "",
})
const state = reactive({
    fullLoading: false,
    tableLoading: false,
    dialogVisible: false,
    formValue: {
        brandName: '',
    },
    formRules: {
        brandName: [{ required: true, message: '请选择品牌名称', trigger: 'change' }],
    },
    allOptions: [],
    options: [],
    options2: [],
    addParams: {},
});
const tableData = ref([]);
const pagination = reactive({
    current: 1,
    size: 20,
    total: 0,
    sizes: [20, 50, 100]
});

const userFormRef = ref();
// toolbar 新增品牌
const handleAdd = () => {
    state.formValue.brandName = null;
    state.dialogVisible = true;
}
// 行操作 删除
const handleDelete = (row) => {
    state.tableLoading = true;
    deleteFun(row.id).then((res) => {
        pagination.current = 1;
        pagination.size = 10;
        intTableData();
    }).finally(() => {
        state.tableLoading = false;
    });
}
// 列表查询
const handleSearch = () => {
    searchFun(1);
}
// 查询 1查询 2重置
const searchFun = (type) => {
    if (type == 2) {
        search.brandName = '';
    }
    pagination.current = 1;
    intTableData();
}
// 获取表格数据
const intTableData = async () => {
    state.fullLoading = true;
    const params = {
        keys: ['current', 'size'],
        formValue: {
            current: pagination.current,
            size: pagination.size,
        }
    }
    for (let key in search) {
        if (search[key]) {
            params.keys.push(key);
            params.formValue[key] = search[key];
        }
    }
    getBrandListFun(params).then((res) => {
        tableData.value = res.data.records;
        pagination.total = res.data.total;
    }).finally(() => {
        state.fullLoading = false;
    });
}
// 编辑确认
const dialogConfirm = () => {
    // 1.校验表单
    userFormRef.value.validate((valid) => {
        if (valid) {
            state.fullLoading = true;
            brandAddFun(state.addParams).then((res) => {
                state.dialogVisible = false;
                intTableData();
            }).finally(() => {
                state.fullLoading = false;
            });
        }
    })
}
// 自定义索引
const indexMethod = (index) => {
    return (pagination.current - 1) * pagination.size + index + 1;
}
let timeout = null;
// 自定义搜索
const filterMethod = (query) => {
    clearTime();
    timeout = setTimeout(() => {
        if (query !== '') {
            state.options = state.allOptions.filter(item => item.value.includes(query));
        } else {
            state.options = state.allOptions;
        }
        clearTime();
    }, 300);
}
const filterMethod2 = (query) => {
    clearTime();
    timeout = setTimeout(() => {
        if (query !== '') {
            state.options2 = state.allOptions.filter(item => item.value.includes(query));
        } else {
            state.options2 = state.allOptions;
        }
        clearTime();
    }, 300);
}
const clearTime = () => {
    if (timeout) {
        clearTimeout(timeout);
    }
}
// 添加弹窗下拉框选择事件
const selectNode = (val) => {
    for (let i = 0; i < state.allOptions.length; i++) {
        const element = state.allOptions[i];
        if (element.brandName === val) {
            state.addParams = {
                brandName: element.brandName,
                outBrandId: element.outBrandId,
                iconUrl: element.iconUrl,
            }
            break;
        }
    }
}
onMounted(() => {
    getThirdBrand().then(res => {
        if (res?.data) {
            state.options = res.data.map((item) => {
                return {
                    label: item.amMainBrandName,
                    value: item.amMainBrandName,
                    brandName: item.amMainBrandName,
                    outBrandId: item.amMainBrandId,
                    iconUrl: item.iconUrl,
                }
            });
            state.allOptions = state.options;
            state.options2 = state.options;
        } else {
            state.options = [];
        }

    })
    intTableData();
});
</script>
<style lang="scss" scoped>
:deep .el-card {
    box-shadow: none !important;
    border-radius: inherit;
    border: none;
}

.pagination-box {
    text-align: right;
}

.el-pagination {
    margin-top: 8px;
    float: right;
}


.header-cell {
    width: 100%;
    position: relative;

    :deep .el-icon {
        position: absolute;
        right: 0;
        font-size: 16px;
        line-height: 23px;
        font-weight: bold;
        display: inline-block;
        cursor: pointer;
        transition: all 0.2s;

        svg {
            height: 23px;
        }
    }

    :deep .el-icon:hover {
        color: #409eff;
    }
}

.header-cell_active {
    :deep .el-icon {
        color: #409eff;
    }
}

.mx-1 {
    cursor: pointer;
}
</style>